import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';

import BankingFAQs from './BankingFAQs';
import CardButton from './CardButton';
import MoreButton from './MoreButton';
import MoveMoneyButton from './MoveMoneyButton';
import StatementButton from './StatementsButton';

export default function NavigationButtons() {
  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap="8px"
      mt={{ xs: '16px', md: '24px' }}
    >
      <Box
        display="flex"
        flexGrow={1}
      >
        <MoveMoneyButton />
      </Box>

      <CardButton />
      <Box display={{ xs: 'none', sm: 'block' }}>
        <StatementButton />
      </Box>
      <Box display={{ xs: 'none', sm: 'block' }}>
        <BankingFAQs />
      </Box>
      <Box display={{ xs: 'block', sm: 'none' }}>
        <MoreButton />
      </Box>
    </Stack>
  );
}
